import styled from 'react-emotion'

const Airmail = styled.div({
  height: 6,
  backgroundColor: 'white',
  backgroundImage: `repeating-linear-gradient(-135deg, #3FA9F5 0px, #3FA9F5 20px, transparent 20px, transparent 32px, #EC1818 32px, #EC1818 52px, transparent 52px, transparent 64px)`,
  width: '100%',
})

export default Airmail
